// Infrastructure Layer - Adaptador para Service Worker
export interface PWAServiceWorkerAdapter {
  register(): Promise<ServiceWorkerRegistration | null>;
  unregister(): Promise<boolean>;
  checkForUpdates(): Promise<boolean>;
}

export class WebPWAServiceWorkerAdapter implements PWAServiceWorkerAdapter {
  private registration: ServiceWorkerRegistration | null = null;

  async register(): Promise<ServiceWorkerRegistration | null> {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return null;
    }

    try {
      this.registration = await navigator.serviceWorker.register('/service-worker.js');
      
      // Escuchar actualizaciones
      this.registration.addEventListener('updatefound', () => {
        const newWorker = this.registration?.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Hay una nueva versión disponible
              window.dispatchEvent(new CustomEvent('pwa-update-available'));
            }
          });
        }
      });

      return this.registration;
    } catch (error) {
      console.error('Error registrando service worker:', error);
      return null;
    }
  }

  async unregister(): Promise<boolean> {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return false;
    }

    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        return await registration.unregister();
      }
      return false;
    } catch (error) {
      console.error('Error desregistrando service worker:', error);
      return false;
    }
  }

  async checkForUpdates(): Promise<boolean> {
    if (!this.registration) {
      return false;
    }

    try {
      await this.registration.update();
      return true;
    } catch (error) {
      console.error('Error verificando actualizaciones:', error);
      return false;
    }
  }
}
